import React from 'react';
import { SVGProps } from './type';

export const IconPaymentLink2 = ({ fill }: SVGProps) => {
  return (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.499 3.5a0.5 0.5 0 0 0 -0.5 0.5v12.498a3 3 0 0 0 3 2.998 3.345 3.345 0 0 0 3.345 -3.346v-0.603a1.05 1.05 0 0 1 1.05 -1.05h3.603V4.5a0.999 0.999 0 0 0 -1.001 -1.001zM3 11.726v4.886a5 5 0 0 0 4.998 4.884h8.998c3.273 0 5.998 -2.651 5.998 -5.949a1.05 1.05 0 0 0 -1.05 -1.05h-3.95V4.5a3 3 0 0 0 -2.998 -3H5.499C4.119 1.5 3 2.618 3 3.999zm9.168 7.77h4.829a4.012 4.012 0 0 0 3.881 -3H13.335a5.325 5.325 0 0 1 -1.165 3m-0.67 -13.996a1.001 1.001 0 0 0 -1.999 0v0.355a2.333 2.333 0 0 0 0.333 4.641h1.335a0.333 0.333 0 1 1 0 0.666H8.834a0.999 0.999 0 1 0 0 1.999h0.666v0.333a0.999 0.999 0 1 0 1.999 0v-0.357a2.333 2.333 0 0 0 -0.33 -4.641h-1.337a0.333 0.333 0 0 1 0 -0.664h2.335a1.001 1.001 0 0 0 0 -1.999h-0.669z"
      fill={fill}
    />
  );
};
